module.exports = __webpack_public_path__ + "img/info_cicle.033624ce.svg";